import enUS from './en-US/index.js'
import zhCN from './zh-CN/index.js'
import deDE from './de-DE/index.js'
import frFR from './fr-FR/index.js'
import ptBR from './pt-BR/index.js'

export default {
  'en-US': enUS,
  'zh-CN': zhCN,
  'de-DE': deDE,
  'fr-FR': frFR,
  'pt-BR': ptBR
} 
